import { render, staticRenderFns } from "./ModalReactivate.vue?vue&type=template&id=2513fa45&"
import script from "./ModalReactivate.vue?vue&type=script&lang=js&"
export * from "./ModalReactivate.vue?vue&type=script&lang=js&"
import style0 from "./ModalReactivate.vue?vue&type=style&index=0&id=2513fa45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports